export default __webpack_public_path__ + "static/media/P500_CoC.1e14c496.pdf";